/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenGoal Platform API
 * Agency-facing API — day-to-day platform usage by agency users.
 * OpenAPI spec version: 1.0
 */

export type ContractsControllerListV1SortOrder = typeof ContractsControllerListV1SortOrder[keyof typeof ContractsControllerListV1SortOrder];


export const ContractsControllerListV1SortOrder = {
  asc: 'asc',
  desc: 'desc',
} as const;
